import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const SessionsChart = ({ weeklyData }) => {
  const mockData = [
    { week: '3/18', sessions: 12 },
    { week: '3/25', sessions: 18 },
    { week: '4/01', sessions: 22 },
    { week: '4/08', sessions: 15 },
    { week: '4/15', sessions: 19 },
    { week: '4/22', sessions: 25 },
  ];

  const dataToRender = weeklyData && weeklyData.length ? weeklyData : mockData;

  const data = {
    labels: dataToRender.map((entry) => `Week of ${entry.week}`),
    datasets: [
      {
        label: 'Sessions Per Week',
        data: dataToRender.map((entry) => entry.sessions),
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        fill: true,
        tension: 0.3,
        pointRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      y: {
        min: 0,
        max: 40,
        ticks: { stepSize: 5 },
        title: { display: true, text: 'Number of Sessions' },
      },
      x: {
        title: { display: true, text: 'Week' },
      },
    },
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: 'Weekly Sessions Overview' },
    },
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-4 my-4">
      <Line data={data} options={options} />
    </div>
  );
};

export default SessionsChart;
